import { jsxs, jsx } from 'react/jsx-runtime';
import { DropdownMenu } from '../DropdownMenu/index.js';
import '../../../../../../../../authentication/context/AuthenticationProvider.js';
import '@geit/ui-components';
import 'react';
import { useCurrentUser } from '../../../../../../../../authentication/hooks/useCurrentUser.js';
import 'qs';
import 'uuid';
import '../../../../../../../../authentication/navigate.js';
import { NO_PHOTO_VALUE } from '../../../../../../helpers/constants.js';
import Anchor from '../../../../../Anchor/index.js';
import { SCAvatar, SCNameContainer, SCFullNameText, SCEmailText, SCDivider, SCSignOutContainer } from './styles.js';
const UserButton = () => {
  const {
    user: {
      avatarName,
      fullName,
      emailId,
      photoBase64
    }
  } = useCurrentUser();
  return /* @__PURE__ */jsxs(DropdownMenu, {
    children: [/* @__PURE__ */jsx(DropdownMenu.Button, {
      children: /* @__PURE__ */jsx(SCAvatar, {
        children: !photoBase64 || photoBase64 === NO_PHOTO_VALUE ? /* @__PURE__ */jsx("span", {
          className: "avatar-label",
          children: avatarName
        }) : /* @__PURE__ */jsx("img", {
          src: photoBase64,
          alt: fullName
        })
      })
    }), /* @__PURE__ */jsxs(DropdownMenu.Menus, {
      children: [/* @__PURE__ */jsxs(SCNameContainer, {
        children: [/* @__PURE__ */jsx("div", {
          children: "Signed in as"
        }), /* @__PURE__ */jsx(SCFullNameText, {
          children: fullName
        }), /* @__PURE__ */jsxs(SCEmailText, {
          children: ["(", emailId, ")"]
        })]
      }), /* @__PURE__ */jsx(SCDivider, {}), /* @__PURE__ */jsx(SCSignOutContainer, {
        children: /* @__PURE__ */jsx(Anchor, {
          noHoverColor: true,
          href: "/logout",
          children: "Sign out"
        })
      })]
    })]
  });
};
export { UserButton };